/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-07-19 17:46:56
 * @LastEditTime: 2019-08-17 16:47:54
 * @LastEditors: Do not edit
 */
import axios from 'axios'
import cache from './cache'

import { Toast } from 'antd-mobile'
import {getTokenAndLogin} from './util';

const instance = axios.create({
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

let requestNext = true;

export function request(url, data={}, {needToken= true, moreClick = true, method= 'post', needCache= false, fullScreen=false}={}) {

  console.log(moreClick, requestNext)

  if(!moreClick && !requestNext) {
    return new Promise((resolve, reject)=>{
      reject("请求太快了!")
    });
  }
  requestNext = false;
  
  function shwoError(errMsg) {
    if (fullScreen) {
      // loading.error(errMsg || '网络异常')
    } else {
      Toast.info(errMsg || '网络异常');
      window.localStorage.removeItem("_ACCESSTOKEN_");
    }
  }
  
  return getTokenAndLogin(needToken).then((token)=> {

    const common = {
      isSign: '',
      sign: '',
      cguid: '',
      timeStamp: '',
    }
    let requestData = Object.assign({}, common, data);

    if (needToken) {
      requestData = Object.assign({}, common, data, { token })
    }

    const config = {
      method,
      url,
      data: requestData
    };
    if (needCache) {
      Object.assign(config, {
        adapter: cache({
          local: false // 是否永久保留在本地，默认为false
        })
      })
    }
    
    return new Promise((resolve, reject)=>{
      instance.request(config)
      .then((response) =>{
        
        const { data = {} } = response;
        
        if (data.code === 14002 || data.code === 14001) {
          window.localStorage.removeItem("_ACCESSTOKEN_");
        }
        requestNext = true;
        resolve(data);
    })
      .catch((error)=>{
        requestNext = true;
        shwoError();
      })
    });


  });
}

export default request;
